// extracted by mini-css-extract-plugin
export default {"view":"HoverWrapper_view__--bLN"};